import React, { Component } from 'react';
import { Big3Common } from '../../../js/IncludeManager'
/* 개발담당:양유빈
 * 화면기능:상가별 상품보기 층보기
 * 세부설명:
*/

export class StoreGoods extends Component {
    static displayName = StoreGoods.name;

    constructor(props) {
        super(props);
        this.state = {
            BldList: [],
            Bld_Code: "",
            Flr_Code: "",
        };
        this.CsName = Big3Common.ContentState;
        this.handleBld_Click = this.handleBld_Click.bind(this);

        this.TempFlrList = [];
    }
    //초기화
    componentDidMount() {
        this.DefaultData()
    }
    async DefaultData() {
        try {
            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Get("api/Common/Common/BldMgt");
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataSet = JSON.parse(Data.multiDataTable);
                const BldList = DataSet.BldList;
                this.TempFlrList = DataSet.FlrList;
                this.setState({
                    BldList: BldList
                });
            }
        }
        catch (e) {
            console.log("DefaultData :", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
    }
    handleBld_Click(event, list) {
        const FlrList = this.TempFlrList.filter(data => data.bld_code === list.bld_code);
        this.props.RenderComponent("StoreGoodsList",
            {
                [this.CsName.Bld_Code]: list.bld_code,
                [this.CsName.Bld_Name]: list.bld_name,
                FlrList: FlrList
            }
        );
        event.preventDefault();
    }
    render() {
        const BldList = this.state.BldList;
        return (
            <div className="p_margin d_padding container_box">
                <div className="recent_product recent_product_v2">
                    <div className="title_box">
                        <div className="title">상가</div>
                    </div>
                    <div className="shop_center_select_box row row-cols-3">
                        {BldList.map(list =>
                            <div className="shop" key={list.bld_code}
                                onClick={(e) => { this.handleBld_Click(e,list) } }
                            >{list.bld_name}</div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}
